import { render } from "./TranslatorPage.vue?vue&type=template&id=06448f58"
import script from "./TranslatorPage.vue?vue&type=script&lang=js"
export * from "./TranslatorPage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__